import React, { useState, useEffect } from "react";
import { getAuth, confirmPasswordReset } from "firebase/auth";
import { useNavigate, useSearchParams } from 'react-router-dom';
import logo from '../../assets/logo/logo.png';


const ResetPassword = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const navigateTo = useNavigate();

    const auth = getAuth();
    const [searchParams] = useSearchParams();
    const oobCode = searchParams.get("oobCode"); // Firebase sends this in query

        useEffect(() => {
        if (!oobCode) {
            navigateTo("/forgot-password");
        }
    }, [oobCode, navigateTo]);

    const getResetPasswordError = (code) => {
    switch (code) {
        case "auth/expired-action-code":
            return "The reset link has expired. Please request a new one.";
        case "auth/invalid-action-code":
            return "The reset link is invalid or has already been used.";
        case "auth/user-disabled":
            return "This account has been disabled.";
        case "auth/weak-password":
            return "Password should be at least 6 characters.";
        default:
            return "Failed to reset password. Please try again.";
    }
};

    const handleReset = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");
        setLoading(true);
        try {
            await confirmPasswordReset(auth, oobCode, password);
            setSuccess("✅ Password reset successful. You can now log in.");
        } catch (error) {
            setError("❌ " + getResetPasswordError(error.code));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)', paddingTop: 80, paddingBottom: 40 }}>
            <div className="header" style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 50%, #1e3c72 100%)',
                color: '#fff',
                padding: '12px 20px',
                zIndex: 1001,
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px',
                borderBottom: '2px solid #4a90e2',
                flexWrap: 'wrap',
            }}>
                {/* Logo and Title */}
                <div style={{
                    display: 'flex',
                    // alignItems: 'center',
                    gap: '16px',
                    margin: '0 auto'
                }}>
                    <img src={logo} alt="logo" width="55px" style={{
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        border: '2px solid #4a90e2',
                        backgroundColor: '#ffffff'
                    }} />
                    <h1 style={{
                        color: "#ffffff",
                        margin: 0,
                        fontSize: '1.8rem',
                        fontWeight: '700',
                        // textAlign: 'center',
                        textShadow: '2px 2px 4px rgba(0,0,0,0.3)',
                        letterSpacing: '1px',
                        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
                    }}>
                        ARTHUR APPLICATION SYSTEM (AAS)
                    </h1>
                </div>
            </div>
            <br />
            <div className="login-container" style={{ maxWidth: 400, margin: "40px auto", padding: 24, borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,0.08)", background: "#fff" }}>
                <h1 style={{ textAlign: "center", marginBottom: 24 }}>enter new password</h1>
                {error && (
                    <div style={{ color: 'red', marginBottom: 12, textAlign: 'center' }}>{error}</div>
                )}
                {success && (
                    <div style={{ color: 'green', marginBottom: 12, textAlign: 'center' }}>{success}</div>
                )}
                <form className="login-form" onSubmit={handleReset} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                    <label style={{ fontWeight: 500 }}>
                        new password
                        <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                                style={{ width: "100%", padding: 8, marginTop: 4, borderRadius: 6, border: "1px solid #ccc" }}
                                placeholder="Enter your password"
                            />
                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{ position: "absolute", right: 12, top: 14, cursor: "pointer", userSelect: "none" }}
                                title={showPassword ? "Hide password" : "Show password"}
                            >
                                {showPassword ? (
                                    <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-5 0-9.27-3.11-11-7.5C3.11 7.11 7.38 4 12 4c1.13 0 2.22.13 3.25.375M19.07 4.93l-14.14 14.14M9.88 9.88A3 3 0 0114.12 14.12" /></svg>
                                ) : (
                                    <svg width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm7.5 0c-1.73 4.39-6 7.5-10.5 7.5S2.23 16.39.5 12C2.23 7.61 6.5 4.5 12 4.5s9.27 3.11 11 7.5z" /></svg>
                                )}
                            </span>
                        </div>
                    </label>

                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 8, marginBottom: 8 }}>
                        <a href="/login" style={{ fontSize: 14, color: '#007bff', textDecoration: 'none' }}>Login</a>
                        <a href="/create-account" style={{ fontSize: 14, color: '#007bff', textDecoration: 'none' }}>Create account</a>
                    </div>
                    <button type="submit" style={{ padding: 10, borderRadius: 6, background: "#007bff", color: "#fff", fontWeight: 600, border: "none", marginTop: 8, display: loading ? 'none' : 'block' }}>reset password</button>
                </form>
                {loading && (
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 16 }}>
                        <div className="loader"></div>
                    </div>
                )}
            </div>
            <footer style={{ textAlign: 'center', marginTop: 40, color: '#fff' }}>
                &copy; {new Date().getFullYear()} Arthur International Agency. All rights reserved.
            </footer>
        </div>
    );
};

export default ResetPassword;